import React from "react";
import { RogeSoyYo } from "@/components/RogeSoyYo";

export const RogeMascota = ({ testid = "gato-roge-sidebar" }) => (
  <div className="px-5 pb-4">
    <div className="relative mx-auto mb-3 w-fit">
      <img src="/roge-cat.png" alt="Gato institucional Roge" data-testid={testid} className="h-28 w-auto drop-shadow-md" />
      <RogeSoyYo />
    </div>
    <p className="font-display text-2xl font-bold leading-none">Roge</p>
    <p className="mt-1 text-xs text-vino-100/70">by Human RMSA</p>
  </div>
);

export const RogeMascotaHeader = () => (
  <div className="flex shrink-0 items-center gap-2 lg:hidden" data-testid="gato-roge-header">
    <img src="/roge-cat.png" alt="Gato institucional Roge" className="h-10 w-auto shrink-0 drop-shadow-sm" />
    <span className="hidden font-display text-lg font-bold leading-none text-vino-800 min-[420px]:inline">Roge</span>
  </div>
);
